// Show modal function
window.showModal = function() {
    $("#modal-window").css("display", "flex");
};

// Hide modal function
window.hideModal = function() {
    $("#modal-window .modal-content").children().remove();
    $("#modal-window").css("display", "none");
};

// Use event delegation to handle close button clicks
$(document).on('click', '#modal-window img.close-icon', function() {
    hideModal();
});

// Close modal when clicking on backdrop
$(document).on('click', '#modal-window', function(e) {
    if (e.target === this) {
        hideModal();
    }
});

// Close modal with Escape key
$(document).on('keydown', function(e) {
    if (e.key === 'Escape' && $("#modal-window").css("display") === "flex") {
        hideModal();
    }
});
